export var KEYCODES = {
    UP: 38,
    DOWN: 40,
    ENTER: 13,
};
